module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calendar_list_view_container"
    }
  }, [_c('div', {
    staticClass: "sidebar_filters"
  }, [_c('section', {
    staticClass: "search_text_container"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.searchText),
      expression: "filters.searchText"
    }],
    attrs: {
      "id": "search_text",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filters.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filters.searchText = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('h3', [_vm._v("By month "), _c('a', {
    staticClass: "clear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearByMonth()
      }
    }
  }, [_vm._v("Clear")])]), _vm._v(" "), _c('div', {
    staticClass: "goup_filters"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    attrs: {
      "for": "search_year"
    }
  }, [_vm._v("Year")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.searchYear),
      expression: "filters.searchYear"
    }],
    attrs: {
      "name": "search_year",
      "id": "search_year"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filters.searchYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.resetFromToDateSearch()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("select")]), _vm._v(" "), _vm._l((_vm.getYearRange), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.searchYear != ""),
      expression: "filters.searchYear != \"\" "
    }],
    staticClass: "form-item"
  }, [_c('label', {
    attrs: {
      "for": "search_year"
    }
  }, [_vm._v("Month")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.searchMonth),
      expression: "filters.searchMonth"
    }],
    attrs: {
      "name": "search_month",
      "id": "search_month"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filters.searchMonth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("select")]), _vm._v(" "), _vm._l((12), function(n) {
    return _c('option', {
      domProps: {
        "value": n - 1
      }
    }, [_vm._v("  " + _vm._s(_vm.displayMonth(n - 1)) + " ")])
  })], 2)])])]), _vm._v(" "), _c('section', [_c('h3', [_vm._v("By date "), _c('a', {
    staticClass: "clear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearByDate()
      }
    }
  }, [_vm._v("Clear")])]), _vm._v(" "), _c('div', {
    staticClass: "goup_filters"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    attrs: {
      "for": "search_day_start"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "value": _vm.filters.searchDateStart
    },
    on: {
      "change": function($event) {
        _vm.resetYearSearch()
      }
    },
    model: {
      value: (_vm.filters.searchDateStart),
      callback: function($$v) {
        _vm.filters.searchDateStart = $$v
      },
      expression: "filters.searchDateStart"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    attrs: {
      "for": "search_day_end"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "value": _vm.filters.searchDateEnd
    },
    model: {
      value: (_vm.filters.searchDateEnd),
      callback: function($$v) {
        _vm.filters.searchDateEnd = $$v
      },
      expression: "filters.searchDateEnd"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollable"
  }, [(_vm.listEvents.length > 0) ? _c('ul', {
    staticClass: "calendar_list"
  }, _vm._l((_vm.listEvents), function(event) {
    return _c('li', {
      class: _vm.classList(event.dateStart)
    }, [_c('a', {
      staticClass: "bg",
      attrs: {
        "href": event.event_url
      }
    }, [_c('div', {
      staticClass: "top"
    }, [_c('h3', [_vm._v(_vm._s(event.longtitle))]), _vm._v(" "), _c('h4', [(_vm.isToday(event.dateStart)) ? _c('span', [_vm._v("Today")]) : _vm._e(), _vm._v(" "), (event.dateStart == event.dateEnd) ? [_vm._v(" \n\t\t\t\t\t\t\t" + _vm._s(_vm.displayDate(event.start)) + " | " + _vm._s(event.datetime) + "\n\t\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (event.dateStart != event.dateEnd && event.datetime == '(All day)') ? [_vm._v(" \n\t\t\t\t\t\t\t" + _vm._s(_vm.displayDate(event.start)) + " to " + _vm._s(_vm.displayDate(event.end)) + " | " + _vm._s(event.datetime) + "\n\t\t\t\t\t\t")] : _vm._e(), _vm._v(" "), (event.dateStart != event.dateEnd && event.datetime != '(All day)') ? [_vm._v(" \n\t\t\t\t\t\t\t" + _vm._s(_vm.displayDate(event.start, true)) + " to " + _vm._s(_vm.displayDate(event.end, true)) + "\n\t\t\t\t\t\t")] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('p', [_vm._v(_vm._s(event.description))])])])])
  })) : _c('div', {
    staticClass: "no_results"
  }, [_vm._v("\n\t\tSorry, No results were found, try again with different filters\n\t")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23fab052","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarList.vue
// module id = 563
// module chunks = 1